export default function initContentTables() {
    document.querySelectorAll('.content-table table, table.content-table, .prose table').forEach((table) => {
        if (table.parentElement.classList.contains('content-table-scroll')) return;

        const wrapper = document.createElement('div');
        wrapper.className = 'content-table-scroll';
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', table.caption?.textContent.trim() || 'Scrollable table');
        table.before(wrapper);
        wrapper.append(table);

        // Only overflowing tables need a keyboard stop. Observe both elements so
        // this also updates when an accordion opens or the viewport changes.
        const observer = new ResizeObserver(() => {
            if (wrapper.scrollWidth > wrapper.clientWidth) {
                wrapper.tabIndex = 0;
            } else {
                wrapper.removeAttribute('tabindex');
            }
        });
        observer.observe(wrapper);
        observer.observe(table);
    });
}
